import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../constants/routes";

export const useDynamicViewportMeta = () => {
  const location = useLocation();
  useEffect(() => {
    const meta =
      document.querySelector('meta[name="viewport"]') ||
      (() => {
        const m = document.createElement("meta");
        m.name = "viewport";
        document.head.appendChild(m);
        return m;
      })();
    const isAuth = location.pathname.startsWith("/login");
    const isMobileLinkedServices = location.pathname.startsWith("/linked-services-mobile");
    const isPaymentThankYou = location.pathname.startsWith(ROUTES.PAYMENT_THANK_YOU);
    const isMobilePayments = 
      location.pathname.startsWith("/payments-mobile") ||
      location.pathname.startsWith("/manage-payments-mobile");
    meta.setAttribute(
      "content",
      isAuth || isMobileLinkedServices || isPaymentThankYou || isMobilePayments
        ? "width=device-width, initial-scale=1"
        : "width=1440, user-scalable=yes"
    );
  }, [location.pathname]);
};
